(function () {
  function normalize(text) {
    return (text || '').replace(/\s+/g, '');
  }

  function getHandle() {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return '';
    var match = canonical.href.match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    return decodeURIComponent(match[1]);
  }

  function getTeaData() {
    return (window.TeaCatalog && window.TeaCatalog.TEA_DATA) || {};
  }

  function removeIngredientParagraph(exp, ingredientText) {
    var target = normalize(ingredientText);
    exp.querySelectorAll('.product__description p').forEach(function (paragraph) {
      if (normalize(paragraph.textContent).indexOf(target) !== -1) {
        paragraph.remove();
      }
    });
  }

  function renderChips(ingredients) {
    var listItems = ingredients.map(function (item) {
      return (
        '<li class="tea-ingredients__item">' +
          '<span class="tea-ingredients__chip">' +
            '<span class="tea-ingredients__name">' + item[0] + '</span>' +
            '<span class="tea-ingredients__effect">' + item[1] + '</span>' +
          '</span>' +
        '</li>'
      );
    }).join('');

    return (
      '<div class="tea-ingredients quick-add-hidden">' +
        '<h3 class="tea-ingredients__heading">茶材</h3>' +
        '<ul class="tea-ingredients__list" role="list">' + listItems + '</ul>' +
      '</div>'
    );
  }

  function getDetailContainer() {
    var mobileDetail = document.querySelector('.product__post-purchase-detail');
    if (mobileDetail && window.matchMedia('(max-width: 749px)').matches) {
      return mobileDetail;
    }
    return document.querySelector('.product__exp-wrapper');
  }

  function initTeaIngredients() {
    if (!window.TeaCatalog) {
      window.setTimeout(initTeaIngredients, 50);
      return;
    }
    if (!window.location.pathname.includes('/products/')) return;
    if (document.querySelector('.tea-ingredients')) return;

    var handle = getHandle();
    var ingredients = getTeaData()[handle];
    if (!ingredients || !ingredients.length) return;

    var container = getDetailContainer();
    if (!container) return;

    var ingredientText = ingredients.map(function (item) { return item[0]; }).join('、');
    removeIngredientParagraph(container, ingredientText);
    if (container !== document.querySelector('.product__exp-wrapper')) {
      var exp = document.querySelector('.product__exp-wrapper');
      if (exp) removeIngredientParagraph(exp, ingredientText);
    }

    var insertBefore = null;
    if (container.classList.contains('product__post-purchase-detail')) {
      insertBefore = null;
    } else {
      var recMount = container.querySelector('[data-tea-recommendations-product]');
      insertBefore = recMount || container.querySelector('[data-instagram-promo]');
    }

    if (insertBefore) {
      insertBefore.insertAdjacentHTML('beforebegin', renderChips(ingredients));
    } else {
      container.insertAdjacentHTML('beforeend', renderChips(ingredients));
    }

    var exp = document.querySelector('.product__exp-wrapper');
    if (exp) {
      var instagramPromo = exp.querySelector('[data-instagram-promo]');
      if (instagramPromo) {
        exp.appendChild(instagramPromo);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTeaIngredients);
  } else {
    initTeaIngredients();
  }
})();
